// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__dH8A1","errorLogs":"styles_errorLogs__3uOGZ"};